import { render, staticRenderFns } from "./Service8Table.vue?vue&type=template&id=710864e5&"
import script from "./Service8Table.vue?vue&type=script&lang=js&"
export * from "./Service8Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports